import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { Radio, ExternalLink, Info } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const CATEGORY_BADGE = {
  sante: { label: 'Santé', color: 'bg-red-500/90' },
  environnement: { label: 'Environnement', color: 'bg-[#4A6B48]/90' },
  social: { label: 'Social', color: 'bg-blue-500/90' },
  emploi: { label: 'Emploi RDC', color: 'bg-[#D87D4A]/90' },
  actualite: { label: 'Actualité', color: 'bg-gray-600/90' },
};

export default function NewsTicker() {
  const [items, setItems] = useState([]);

  const fetchNews = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/news`);
      setItems(res.data);
    } catch (e) {
      console.error('Failed to load news ticker:', e);
    }
  }, []);

  useEffect(() => {
    fetchNews();
    // Refresh every 5 minutes so admin updates appear without reloading
    const interval = setInterval(fetchNews, 5 * 60 * 1000);
    return () => clearInterval(interval);
  }, [fetchNews]);

  if (items.length === 0) return null;

  // Duplicate items so the marquee loops seamlessly
  const looped = [...items, ...items];

  return (
    <div className="bg-[#2E332D] text-white border-y border-[#4A6B48] overflow-hidden" data-testid="news-ticker">
      <div className="flex items-stretch">
        <div className="bg-[#D87D4A] flex items-center gap-2 px-4 py-2 shrink-0">
          <Radio size={16} className="animate-pulse" />
          <span className="text-xs font-bold uppercase tracking-wide whitespace-nowrap">Actualité du monde</span>
        </div>
        <div className="overflow-hidden flex-1 relative">
          <div className="ticker-track flex items-center whitespace-nowrap py-2">
            {looped.map((item, idx) => {
              const meta = CATEGORY_BADGE[item.category] || CATEGORY_BADGE.actualite;
              return (
                <span key={`${item.news_id}-${idx}`} className="inline-flex items-center gap-2 px-4">
                  <span className={`text-[10px] font-bold uppercase ${meta.color} text-white px-2 py-0.5 rounded-full`}>
                    {meta.label}
                  </span>
                  <a
                    href={item.source_url}
                    target="_blank"
                    rel="noopener noreferrer nofollow"
                    className="text-sm font-medium hover:underline inline-flex items-center gap-1"
                    data-testid={`news-link-${item.news_id}`}
                  >
                    {item.title}
                    <ExternalLink size={11} className="opacity-70" />
                  </a>
                  <span className="text-xs text-white/60 italic">— {item.source_name}</span>
                  <span className="text-white/30 mx-2">•</span>
                </span>
              );
            })}
          </div>
        </div>
        <div
          className="hidden md:flex items-center gap-1 px-3 py-2 bg-[#1E211D] text-white/60 text-[10px] italic shrink-0"
          title="Liens externes. Ces contenus n'engagent pas CRESA ASBL."
        >
          <Info size={11} />
          <span className="whitespace-nowrap">N&apos;engage pas CRESA</span>
        </div>
      </div>
    </div>
  );
}
